import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { DisplayType } from 'entities/back-counter-tool';
import { Branch } from 'entities/branch';
import { Cart } from 'entities/cart-search';
import { Part } from 'entities/part';
import { Observable } from 'rxjs';
import { SourceLocationType } from 'services/logger.service';
import { AppState } from 'store/app-state';
import * as BranchSelectors from 'store/branch/branch.selectors';

@Component({
    selector: 'part-card',
    templateUrl: './part-card.component.html',
    standalone: false
})
export class PartCardComponent {
  private _index: number = -1;
  @Input() set index(value: number) {
    this._index = value;
  }
  @Input() part: Part;
  @Input() partType: SourceLocationType;
  @Input() isInModal: boolean = false;
  @Input("allowPriceAdjust") set allowPriceAdjustAttribute(value: any) {
    this.allowPriceAdjust = value === "" || value;
  }
  @Input() sourcePart: Part = null;
  @Input() displayType: DisplayType;
  @Output() addedToCart: EventEmitter<Part> = new EventEmitter();
  @Output() partChange = new EventEmitter<Part>();
  @Output() navigateToPart = new EventEmitter<Part>();
  @Output() partAddedToRequest = new EventEmitter<Part>();

  get idSuffix(): string {
    return this._index > -1 ? `_${this._index}` : "";
  }

  addToCartParameters: Cart = new Cart();
  allowPriceAdjust: boolean = false;

  branch$: Observable<Branch> = this.store.select(BranchSelectors.selectedBranch);

  constructor(private readonly store: Store<AppState>) { }
  changeFavorite(part: Part): void {
    this.partChange.emit(part);
  }

  onNavigateToPart(part: Part): void {
    this.navigateToPart.emit(part);
  }

}
